import { useInfiniteQuery } from '@tanstack/react-query';

import { fetchGenAiRequestHistory } from '@/api/v4/genai-request-history.api';
import { QueryKey } from '@/config/query-client';

export const useExploreHistory = () => {
  return useInfiniteQuery({
    queryKey: [QueryKey.ExploreHistory],
    queryFn: ({ pageParam = 1 }) => {
      const params = {
        page: pageParam,
        size: 20,
      };
      return fetchGenAiRequestHistory(params);
    },
    initialPageParam: 1,
    staleTime: 1000 * 60 * 5,
    getNextPageParam: (lastPage, allPages) => {
      const nextPage = lastPage.length ? allPages.length + 1 : undefined;
      return nextPage;
    },
  });
};
